import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { getSetBackground } from '@sorare/core/src/set';

import defaultBackground from './assets/default.webp';

const Root = styled.div`
  position: absolute;
  inset: 0;
  background: var(--bg-url) no-repeat center center;
  background-size: cover;
  z-index: 0;
`;

type Props = {
  golden?: boolean;
  slug?: string;
};
export const Background = ({ golden, slug = '' }: Props) => {
  return (
    <Root
      style={
        {
          background: `
            ${golden ? 'linear-gradient(#FFC534, #FFC534)' : 'linear-gradient(transparent, transparent)'},
            ${getSetBackground(slug, true)?.background || `url(${defaultBackground}) no-repeat center center / cover`}
          `,
          backgroundBlendMode: `${'color'},${getSetBackground(slug, true)?.backgroundBlendMode || 'normal'}`,
        } as CSSProperties
      }
    />
  );
};
